"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PasswordModel = void 0;

var Yup = __importStar(require("yup"));

require("./validators");

exports.PasswordModel = {
  password: {
    label: 'Mot de passe',
    placeholder: 'Saisir votre mot de passe',
    type: 'password',
    icon: 'key-lock-1',
    schema: Yup.string().min(8, 'Le champ mot de passe doit faire au moins 8 caractères.').isPassword('Le champ mot de passe doit remplir toutes les conditions.').required('Le champ mot de passe doit être rempli.')
  },
  repeated_password: {
    label: 'Confirmation du mot de passe',
    placeholder: 'Saisir à nouveau votre mot de passe',
    type: 'password',
    icon: 'key-lock-1',
    schema: Yup.string().oneOf([Yup.ref('password')], 'Les champs mot de passe doivent être identiques.').required('Le champ mot de passe doit être rempli.')
  }
};
exports.default = exports.PasswordModel;